import { NotificationConstants } from '../constants';
import { axiosFetch } from '../../utils/AxiosFetch';
import { SnackbarActions } from './snackbar.actions';
export const notification_list = () => (dispatch) => {

    axiosFetch({
        url: "/Notifications/new",
        method: "get",
    })
        .then((res) => {
            if (res.status === 200) {
                dispatch(notification_success(res));
            }
            if (res.status === 400) {
                dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
            }
            else if (res.status === 401) {
                window.location.href = '/';
            }

        },
            (err) => {

                dispatch(notification_failure(err));
            }
        );


    function notification_success(data) {

        return {
            type: NotificationConstants.GET_NOTIFICATION_LIST_SUCCESS,
            payload: data
        }
    }

    function notification_failure(err) {

        return {
            type: NotificationConstants.GET_NOTIFICATION_LIST_FAILURE,
            payload: err
        }
    }

}